import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $MainTitle = styled.div`
  font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  color: ${({ theme }) => theme.newUI.defaultColors.text};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(5)};
`;

export const $Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing(10)};
`;

export const $Separator = styled.div`
  margin: ${spacing(10)} 0;
`;
